var MarketDepthStreamUseCase = /** @class */ (function () {
    function MarketDepthStreamUseCase(streamRepo) {
        this.streamRepo = streamRepo;
    }
    MarketDepthStreamUseCase.prototype.activeScreen = function (active) {
        throw new Error("Method not implemented.");
    };
    MarketDepthStreamUseCase.prototype.streamQuote = function (reqType, subscribe, callBack, symbols) {
        this.streamRepo.streamQuote(reqType, subscribe, callBack, symbols);
    };
    return MarketDepthStreamUseCase;
}());
export default MarketDepthStreamUseCase;
